/**
 * This is default tabs class with a11y functions
 * Please fee free to update this class directly or inherit from it
 */
import Flickity from "flickity";
import {
  flickityReadyHandler,
  flickityChangeHandler,
  flickitySettleHandler,
} from "../utils/flickity";

export default class TabbedFeature {
  constructor(elem, APP) {
    this.elem = elem;
    this.tablist = this.elem.querySelector(".js-tablist");
    this.tabs = this.elem.querySelectorAll('.js-tab:not([disabled="true"])');
    this.labels = this.elem.querySelectorAll(
      '.js-tab:not([disabled="true"]) .js-tab-label'
    );
    this.panels = this.elem.querySelectorAll(".js-panel");
    this.indicator = this.elem.querySelector(".js-tab-indicator");
    this.currentTab = 0;

    // mobile
    this.carousel = this.elem.querySelector(".js-slider");
    this.slides = this.elem.querySelectorAll(".js-slide");
    this.slidesLength = this.slides.length;
    this.carouselIndicator = this.elem.querySelector(
      ".js-tab-carousel-indicator"
    );
    this.slideHeight = 0;
    this.flkty;
    this.currentSlideIndex = 0;

    this.windowWidth = window.innerWidth;
  }

  updateTabs() {
    this.tabs.forEach((tab, i) => {
      tab.setAttribute("aria-selected", this.currentTab === i ? true : false);
      tab.setAttribute("tabindex", this.currentTab === i ? 0 : -1);
      if (this.currentTab === i) {
        // tab.focus();
        this.indicator.style.left = `${tab.offsetLeft}px`;
        this.indicator.style.width = `${this.labels[i].offsetWidth}px`;
      }
    });

    this.panels.forEach((panel, i) => {
      panel.classList[this.currentTab === i ? "add" : "remove"]("active");
    });
  }

  addKeyHandler() {
    this.tablist.addEventListener("keydown", (e) => {
      switch (e.key) {
        case "ArrowLeft":
          this.currentTab--;
          if (this.currentTab < 0) this.currentTab = this.tabs.length - 1;
          break;

        case "ArrowRight":
          this.currentTab++;
          if (this.currentTab >= this.tabs.length) this.currentTab = 0;
          this.currentTab;
          break;

        // optional
        // case "Home":
        //   e.preventDefault();
        //   this.currentTab = 0;
        //   break;

        // case "End":
        //   e.preventDefault();
        //   this.currentTab = this.tabs.length;
        //   break;
      }

      this.updateTabs();
    });
  }

  tabClickHandler() {
    this.tabs.forEach((tab, i) => {
      tab.addEventListener("click", () => {
        this.currentTab = i;
        this.updateTabs();
      });
    });
  }

  // mobile carousel
  setupCarousel() {
    this.flkty = new Flickity(this.carousel, {
      accessibility: false,
      prevNextButtons: this.slidesLength > 1,
      pageDots: false,
      autoPlay: false,
      imagesLoaded: true,
      cellAlign: "left",
      wrapAround: true,
      groupCells: true,
      on: {
        ready: () => {
          this.carouselIndicator.style.width = `${
            (window.innerWidth - 20) / this.slidesLength
          }px`;
        },
        change: (index) => {
          this.currentSlideIndex = index;
          this.carouselIndicator.style.left = `${
            ((window.innerWidth - 20) / this.slidesLength) * index
          }px`;
        },
        settle: () => {
          flickitySettleHandler(this.carousel.querySelectorAll(".js-slide"));
        },
      },
    });
  }

  resizeHandler() {
    // carousel
    this.carouselIndicator.style.width = `${
      (window.innerWidth - 20) / this.slidesLength
    }px`;

    this.carouselIndicator.style.left = `${
      ((window.innerWidth - 20) / this.slidesLength) * this.currentSlideIndex
    }px`;

    // tab
    this.indicator.style.left = `${this.tabs[this.currentTab].offsetLeft}px`;
    this.indicator.style.width = `${
      this.labels[this.currentTab].offsetWidth
    }px`;

    // resize carousel
    if(this.windowWidth != window.innerWidth) {
      this.flkty.destroy();
      this.setupCarousel();
      this.windowWidth = window.innerWidth;
    }
  }

  init() {
    this.addKeyHandler();
    this.tabClickHandler();
    this.updateTabs();
    this.setupCarousel();

    window.addEventListener("resize", () => {
      this.resizeHandler();
    });
  }
}
